import { render, staticRenderFns } from "./wizardUploadMaterial.vue?vue&type=template&id=cd0808f4&scoped=true"
import script from "./wizardUploadMaterial.vue?vue&type=script&lang=js"
export * from "./wizardUploadMaterial.vue?vue&type=script&lang=js"
import style0 from "./wizardUploadMaterial.vue?vue&type=style&index=0&id=cd0808f4&prod&scoped=true&lang=css"
import style1 from "./wizardUploadMaterial.vue?vue&type=style&index=1&id=cd0808f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd0808f4",
  null
  
)

export default component.exports